module.exports = __webpack_public_path__ + "img/moby_dick.8dfb45ef.jpg";